import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import api from '../../Axios/middleware';
import { failureGetSpace, successGetSpace } from './SpaceSlicer';
import { ISlotList } from '../../../Pages/Slot/ISlot';
import { PayloadAction } from '@reduxjs/toolkit';
import { failureAddSpace, successAddSpace } from './AddSpaceSlicer';
import { failureUpdateSpace, successUpdateSpace } from './UpdateSpaceSlicer';
import { failureDeleteSpace, successDeleteSpace } from './DeleteSpaceSlice';
import { Phone } from '@mui/icons-material';
import {
  failureUpdateSpaceOrder,
  successUpdateSpaceOrder,
} from './UpdateSpaceOrderSlicer';

const SpaceApi = (action: PayloadAction<any>) => {
  return api.get(`parking-slot/${action.payload}`);
};

export function* SpaceCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(SpaceApi, action);
    yield put(successGetSpace(response.data));
  } catch (error) {
    yield put(failureGetSpace(error));
  }
}

// add Space
const AddSpaceApi = (action: PayloadAction<ISlotList>) => {
  // const data = {
  //   level_id: action.payload.level_id,
  //   level_diagram: action.payload.level_diagram,
  //   status: action.payload.status,
  //   location_id: action.payload.location_id,
  // };

  // return api.post('/levels/create', data);

  return api.post('/parking-slot/create', action.payload);
};

export function* AddSpaceCall(action: PayloadAction<ISlotList>) {
  try {
    const response: AxiosResponse = yield call(AddSpaceApi, action);
    yield put(successAddSpace(response.data));
  } catch (error) {
    yield put(failureAddSpace(error));
  }
}

// update Space
const UpdateSpaceApi = (action: PayloadAction<ISlotList>) => {
  const data = {
    zone_id: action.payload.zone_id,
    space_name: action.payload.space_name,
    space_id: action.payload.space_id,
    parking_type: action.payload.parking_type,
    location_id: action.payload.location_id,
    level_id: action.payload.level_id,
    fixture_id: action.payload.fixture_id,
    x: action.payload.x,
    y: action.payload.y,
  };

  const url = `/parking-slot/${action.payload.id}`;

  return api.put(url, data);
};

export function* UpdateSpaceCall(action: PayloadAction<ISlotList>) {
  try {
    const response: AxiosResponse = yield call(UpdateSpaceApi, action);
    yield put(successUpdateSpace(response.data));
  } catch (error) {
    yield put(failureUpdateSpace(error));
  }
}

const UpdateSpaceOrderApi = (action: PayloadAction<ISlotList>) => {
  const url = `/parking-slot/spaceOrder`;

  return api.patch(url, action.payload);
};

export function* UpdateSpaceOrderCall(action: PayloadAction<ISlotList>) {
  try {
    const response: AxiosResponse = yield call(UpdateSpaceOrderApi, action);
    yield put(successUpdateSpaceOrder(response.data));
  } catch (error) {
    yield put(failureUpdateSpaceOrder(error));
  }
}


// delete Space
const DeleteSpaceApi = (action: PayloadAction<number>) => {
  return api.delete(`/parking-slot/${action.payload}`);
};
export function* DeleteSpaceCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteSpaceApi, action);
    yield put(successDeleteSpace(response.data));
  } catch (error) {
    yield put(failureDeleteSpace(error));
  }
}
